import React, { useContext, useState } from "react";
import { Box, Container, Grid, Typography, useMediaQuery } from "@mui/material";
import {
  StyledButton,
  ToastNotify,
} from "../components/SmallComponents/AppComponents";
import FeaturedSlider from "./FeaturedSlider";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { AppContext } from "../utils";
import {
  minterReadFunction,
  minterWriteFunction,
  nftReadFunction,
} from "../ConnectivityAssets/hooks";
import Loading from "../components/SmallComponents/loading";
import { formatUnits, parseUnits } from "viem";

function HeroSection() {
  const { account } = useContext(AppContext);
  const matches = useMediaQuery("(max-width:960px)");
  const [counter, setCounter] = useState(1);
  const [loading, setLoading] = useState(false);
  const [alertState, setAlertState] = useState({
    open: false,
    message: "",
    severity: undefined,
  });
  const decrement = () => {
    if (counter === 1) {
      setCounter(1);
    } else {
      setCounter(counter - 1);
    }
  };
  const buyHandler = async () => {
    if (!account) {
      setAlertState({
        open: true,
        message: "Please connect your wallet",
        severity: "error",
      });
    } else {
      try {
        setLoading(true);
        let fee = await minterReadFunction("fee");
        fee = +formatUnits(fee.toString(), 18) * +counter;
        // console.log(fee, "fee");
        // console.log(parseUnits(fee.toString(), 18), "fee");
        let totalSupply = await nftReadFunction("totalSupply");
        let hashes = [];
        let j = +totalSupply.toString();
        for (let index = 0; index < +counter; index++) {
          let hash = `https://ipfs.io/ipfs/QmPCJoECZku6BX8PKKqQL8TdSLvBqf2bm1zYCvvCkuERJj/${
            j + 1
          }.json`;
          hashes.push(hash);
          j++;
        }
        // console.log(hashes, counter, "hashes, counter");
        await minterWriteFunction(
          "buyNft",
          [hashes, counter],
          parseUnits(fee.toString(), 18)
        );
        setLoading(false);
        setAlertState({
          open: true,
          message: "Success, Transection Confirmed",
          severity: "success",
        });
        setCounter(1);
      } catch (error) {
        console.log(error, "error");
        setLoading(false);
        setAlertState({
          open: true,
          message: error?.shortMessage,
          severity: "error",
        });
      }
    }
  };
  return (
    <>
      <Box pb={5}>
        <Loading loading={loading} />
        <ToastNotify alertState={alertState} setAlertState={setAlertState} />
        <Container maxWidth="lg">
          <Grid container spacing={3} mt={1}>
            <Grid item xs={12} md={6}>
              <Typography
                sx={{
                  fontSize: matches ? "40px" : "56px",
                  fontWeight: matches ? "500" : "700",
                  color: "#000000",
                  fontFamily: "DM Sans",
                  lineHeight: matches ? "38px" : "60px",
                }}
              >
                Welcome to <span style={{ color: "#00b5cd" }}>ArbinuNFTs</span>
              </Typography>
              <Typography
                sx={{
                  my: 3,
                  fontSize: matches ? "16px" : "22px",
                  fontWeight: "500",
                  color: "#000",
                  fontFamily: "DM Sans",
                }}
              >
                Welcome to ArbinuNFTs, where your investments go beyond just a
                picture. Our NFTs are designed to generate ongoing returns for
                holders. With a 2% tax fee shared among ArbinuNFT holders and
                15% of the total supply allocated for harvesting over time,
                simply holding our NFTs ensures you earn passive income
                effortlessly. Explore the future of NFT investing with
                ArbinuNFTs today.
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} mt={matches ? 6 : 0}>
              <FeaturedSlider />
              <Box
                mt={3}
                display="flex"
                alignItems="center"
                justifyContent="space-evenly"
              >
                <Box display="flex" alignItems="center">
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "50%",
                      width: "40px",
                      height: "40px",
                      background: "#00b5cd",
                      border: "4px solid #40C7F1",
                      color: "#fff",
                      "&:hover": {
                        background: "transparent",
                        color: "#00b5cd",
                        cursor: "pointer",
                        border: "4px solid #3749e9",
                      },
                    }}
                    onClick={decrement}
                  >
                    <RemoveIcon />
                  </Box>
                  <Typography mx={3} fontSize="30px" fontFamily="DM Sans">
                    {counter}
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "50%",
                      width: "40px",
                      height: "40px",
                      background: "#00b5cd",
                      border: "4px solid #40C7F1",
                      color: "#fff",
                      "&:hover": {
                        background: "transparent",
                        color: "#00b5cd",
                        border: "4px solid #3749e9",
                        cursor: "pointer",
                      },
                    }}
                    onClick={() => setCounter(counter + 1)}
                  >
                    <AddIcon />
                  </Box>
                </Box>
                <StyledButton width="90px" onClick={() => buyHandler()}>
                  {" "}
                  MINT
                </StyledButton>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
}

export default HeroSection;
